import Negoce from '../index';
import SubmissionsFiles from './SubmissionsFiles';
import SubmissionsRecap from './SubmissionsRecap';

import { useUserMe } from 'apiTyped/hooks/users.query';
import { isUserServicesList } from 'utils/routeAccess';
import { NEGOCE } from 'constants/routes';

const Index = () => {
  const { user } = useUserMe();
  return (
    <Negoce>
      {isUserServicesList(user.services, NEGOCE.audit_de_place) && (
        <SubmissionsRecap />
      )}
      <SubmissionsFiles />
    </Negoce>
  );
};

export default Index;
